import React from 'react';
import { useTranslation } from 'react-i18next';
import { ResidenceMapMarker } from '../../../../graphql/graphql';
import useScreenSize from '../../../../hooks/useScreenSize';
import { PanelContent } from '../../../ItemsMap/MapSidePanel/styled';
import { ModalContent } from '../../../ItemsMap/MapItemModal/styled';
import { ResidenceCard } from '../../../Cards/ResidencesCard';
import { Button } from '../../../ui/Button';
import { ResidenceCardWrapper, ResidenceName } from './styled';

interface MapResidencesListProps {
  items: (ResidenceMapMarker | undefined)[];
  isPerUnit: boolean;
}

export const MapResidencesList: React.FC<MapResidencesListProps> = ({
  items,
  isPerUnit
}) => {
  const { t } = useTranslation();
  const { isSmallOrLargeDesktop } = useScreenSize();

  const ComponentWrapper = isSmallOrLargeDesktop ? PanelContent : ModalContent;

  return (
    <ComponentWrapper>
      {items.map(residence => {
        if (!residence) return null;

        return (
          <ResidenceCardWrapper key={residence?.residenceId}>
            <ResidenceName tag="title_3_new">{residence.name}</ResidenceName>
            <ResidenceCard
              {...residence}
              cypress="residence-card-link"
              hideResidenceName
              showPerUnit={isPerUnit}
              button={<Button text={t('sections.residences.view_residence')} />}
            />
          </ResidenceCardWrapper>
        );
      })}
    </ComponentWrapper>
  );
};
